/**
 * Where a banner-style link takes the customer — one routing table shared by
 * the Home / Offers banners (BannerSlot) and the launch pop-up (LaunchPopup,
 * Business Rule #64). Link targets are stable identifiers (item NAME, category
 * name, offer / pass id) so Rista re-syncs never break them.
 */

/**
 * Open a banner link: in-app routes through React Router, `external` in a new tab.
 * @param {{type?: string, target?: string|null}} link
 * @param {Function} navigate - React Router's navigate
 */
export function followBannerLink(link, navigate) {
  const { type, target } = link || {};
  switch (type) {
    case 'menu_item':
      // /menu handles ?search= so an item deep-links by name.
      if (target) navigate(`/menu?search=${encodeURIComponent(target)}`);
      break;
    case 'category':
      if (target) navigate(`/menu?category=${encodeURIComponent(target)}`);
      break;
    case 'offer':
      // The Offers page reads ?highlight= to pulse the matching card.
      navigate(target ? `/offer-of-the-day?highlight=${encodeURIComponent(target)}` : '/offer-of-the-day');
      break;
    case 'subscription':
      navigate(target ? `/passes/${encodeURIComponent(target)}` : '/subscriptions');
      break;
    // Whole-page links — no target; the destination page reads the customer's
    // selected branch from localStorage itself.
    case 'menu_page':
      navigate('/menu');
      break;
    case 'offers_page':
      navigate('/offer-of-the-day');
      break;
    case 'subscriptions_page':
      navigate('/subscriptions');
      break;
    case 'external':
      if (target) window.open(target, '_blank', 'noopener,noreferrer');
      break;
    case 'none':
    default:
      // Decorative — no navigation.
      break;
  }
}
